import { useStyles } from "./Esport.style";
import { MediaFeed } from "../../components/common/GameFeed/MediaFeed";
import { Icon } from "../../components/core/Icon/Icon";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyColor, TypographyVariant } from "../../constants/typography";
import { map } from "lodash-es";
import { ESPORTS_FEED, ESPORTS_ICON_LIST } from "../../constants/services";
import { StaticImage } from "../../components/common/StaticImage";
import { NotchItem } from "../../components/common/NotchItem/NotchItem";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LaunchPad from "../../components/common/ServiceSelection/LaunchPad";

const Esport = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openIframe, setOpenIframe] = useState(false);

  return (
    <div className={classes.root}>
      {openIframe && (
        <>
          <iframe
            id="feature-item-iframe"
            title="feature-item-iframe"
            src={"https://za-vc.blg.gg/"}
            className={classes.featureIframe}
          />
          <NotchItem onClose={() => setOpenIframe(false)} open={true} />
        </>
      )}
      <MediaFeed
        background={ESPORTS_FEED.background}
        video={ESPORTS_FEED.video}
        className={classes.mediaFeed}
      />
      <div className={classes.content}>
        <div className={classes.mainContent}>
          <div className={classes.reward}>
            <Icon name="icon-bold-cup" size={24} className={classes.cupIcon} />
            <Typography variant={TypographyVariant.BodyB4Bold}>
              5000 {t("common_Coins")}
            </Typography>
          </div>
          <Typography variant={TypographyVariant.BodyB1Bold}>
            {t("common_Battle League Gaming")}
          </Typography>
          <Typography variant={TypographyVariant.BodyB6Medium}>
            {t("common_espport_descrip")}
          </Typography>
          <div className={classes.esportsList}>
            {map(ESPORTS_ICON_LIST, (icon) => (
              <StaticImage
                src={icon.src1x}
                src2x={icon.src2x}
                src3x={icon.src3x}
                key={icon.id}
                className={classes.esportIcon}
              />
            ))}
          </div>
        </div>
        <div className={classes.footerBottom}>
          <button
            className={classes.button}
            onClick={() => setOpenIframe(true)}
          >
            <Typography
              variant={TypographyVariant.BodyB3Bold}
              color={TypographyColor.Secondary}
            >
              {t("common_Join now")}
              <Icon
                name="icon-vector-right"
                size={14}
                className={classes.arrowIcon}
              />
            </Typography>
          </button>
        </div>
      </div>
      <LaunchPad />
    </div>
  );
};

export default Esport;
